export const domainRegexp = new RegExp(
  [
    '^(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?\\.)*', // Optional subdomains
    '[a-z0-9](?:[-a-z0-9]*[a-z0-9])?', // Domain name (allows single char)
    '\\.[a-z]{2,}', // TLD
    ')$',
  ].join(''),
  'i',
)
